import {Injectable} from '@angular/core';
import {ItemGLSetup} from '@model/ItemGLSetup';
import {HttpHeaders} from '@angular/common/http';
import {ConfigurationService} from '~/app/core/services/configuration.service';
import {ErrorService} from '~/app/core/services/error.service';
import {Observable,lastValueFrom} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ItemGLSetupDetail} from '@model/ItemGLSetupDetail';
import {BaseService} from "~/app/core/services/base.service";

@Injectable({
  providedIn: 'root'
})
export class ItemGlSetupService {

  readonly ADD_ITEM = '/itemgl/addItem/';
  readonly DELETE_ITEM = '/itemgl/delete/';
  readonly ITEMS_GL_LIST = '/itemgl/itemsgllist/';
  readonly ITEMS_IN_GL = '/itemgl/itemsingl/';
  readonly UPDATE_GL_ITEM = '/itemgl/updateglitem/';
  public hoId: string = '';

  constructor(private baseService: BaseService,
              private configuration: ConfigurationService,
              private errorService: ErrorService) {
  }

  addItem(item: ItemGLSetup): Observable<any> {
    return this.baseService.postHttpJsonObject<any>(
      'addItem',
      'item-gl-setup-service',
      this.configuration.RESTURL + this.ADD_ITEM, JSON.stringify(item))
      .pipe(
        catchError(this.errorService.handleError('item-gl-setup.service addItem(itemGLSetup)', []))
      );
  }

  delete(deleteArray: any[]): Observable<any> {
    const test = JSON.stringify(deleteArray);
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(deleteArray)

    };
    return this.baseService.deleteHttpObject<any>(
      'delete',
      'item-gl-setup-service',
      this.configuration.RESTURL + this.DELETE_ITEM,
      options)
      .pipe(
        catchError(this.errorService.handleError('item-gl-setup.service delete(hoId, glCode)', []))
      );
  }

  async getItemsGlList(hoId: string) {
    this.hoId = hoId;
    console.warn(this.configuration.RESTURL + this.ITEMS_GL_LIST + hoId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getItemsGlList',
      'item-gl-setup-service',
      this.configuration.RESTURL + this.ITEMS_GL_LIST + hoId))
      .catch(this.errorService.handleError('item-gl-setup.service getItemsGlList(hoId)', []));
    return results as ItemGLSetup[];
  }

  updateGlItem(itemList: ItemGLSetup[]): Observable<any> {
    return this.baseService.putHttpObject<any>(
      'updateGlItem',
      'item-gl-setup-service',
      this.configuration.RESTURL + this.UPDATE_GL_ITEM, itemList)
      .pipe(
        catchError(this.errorService.handleError('item-gl-setup.service  updateGlItem', []))
      );
  }

  async getItemsInGl(hoId: string, glCode: string) {
    const results = await lastValueFrom(this.baseService.getHttp(
      'getItemsInGl',
      'item-gl-setup-service',
      this.configuration.RESTURL + this.ITEMS_IN_GL + hoId + '?code=' + glCode))
      .catch(this.errorService.handleError('item-gl-setup.service getItemsInGl(hoId, glCode)', []));
    return results as ItemGLSetupDetail[];
  }
}

